// AUTO-GENERATED by scripts/build-registry.js: study entry for meteorology/wind.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/meteorology/wind/wind.js';

mount([g0]);
